import { sessionKeeper } from "@cores/sessionKeeper";
import menuService from "@services/menuService";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import theme from "@styles/theme";
import equal from "deep-equal";
import { AppBar, Grid, Toolbar } from "@mzc-pdc/ui";
import Logo from "./Logo";
import { alpha } from "@mui/material";
import { siteMode } from "@cores/siteMode";

const HeaderForDefaultLogo = () => {
    const isLxhausys = window.location.hostname.indexOf("lxhausys.") > -1;

    return (
        <>
            <AppBar
                position="fixed"
                sx={{
                    backgroundColor: theme.palette.background.default,
                    color: theme.palette.text.primary,
                    fill: theme.palette.text.primary,
                    boxShadow: `none`,
                    borderBottom: `1px solid ${alpha(theme.palette.greySecondary[300], 0.32)}`,
                    zIndex: (props) => props.zIndex.drawer + 1,
                }}
            >
                <Toolbar sx={{ padding: `0 !important` }}>
                    <Grid container justifyContent={`space-between`} alignItems={`center`}>
                        <Grid item pl={2.5}>
                            <Logo
                                to={"/"}
                                imgSrc={
                                    isLxhausys
                                        ? "https://mzc-cm-lxhausys-common-resources.s3.amazonaws.com/uploads/logos/1717998451lx8jx5h7_cpm_custom_logo.png"
                                        : null
                                }
                                fill={theme.palette.text.primary}
                            />
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </>
    );
};

export default HeaderForDefaultLogo;
